import React, { useState } from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import AIUsage from './AIUsage';
import AICosts from './AICosts';
import './AIMonitoring.scss';

const AIMonitoring = () => {
    const [activeTab, setActiveTab] = useState('usage');
    const { t } = useLanguage();

    return (
        <div className="ai-monitoring">
            <div className="monitoring-header">
                <h1>{t('aiMonitoring')}</h1>
                <p>{t('aiMonitoringDescription')}</p>
            </div>

            <div className="monitoring-tabs">
                <button
                    className={`tab-button ${activeTab === 'usage' ? 'active' : ''}`}
                    onClick={() => setActiveTab('usage')}
                >
                    {t('aiUsage')}
                </button>
                <button
                    className={`tab-button ${activeTab === 'costs' ? 'active' : ''}`}
                    onClick={() => setActiveTab('costs')}
                >
                    {t('aiCosts')}
                </button>
            </div>

            <div className="monitoring-content">
                {activeTab === 'usage' && <AIUsage />}
                {activeTab === 'costs' && <AICosts />}
            </div>
        </div>
    );
};

export default AIMonitoring;